import { Box, Chip, Typography } from '@mui/material'
import moment from 'moment'

const TYPE_LABEL = { check: 'Full Check', quick_add: 'Quick Top-up' }

const historyColumns = () => [
  {
    field: 'createdAt',
    headerName: 'Date',
    flex: 1,
    valueGetter: (value, row) => row.createdAt,
    renderCell: ({ row }) => (
      <Box>
        <Typography fontWeight={600}>
          {moment(row.createdAt).format('DD MMM YYYY')}
        </Typography>
        <Typography color="text.secondary" fontSize={12}>
          {moment(row.createdAt).format('HH:mm')}
        </Typography>
      </Box>
    ),
  },
  {
    field: 'vehicleOrAsset',
    headerName: 'Vehicle / Asset',
    flex: 1,
    valueGetter: (value, row) =>
      row?.makeReadyInventory?.vehicleId?.callSign ??
      row?.makeReadyInventory?.assetId?.assetID ??
      '',
  },
  {
    field: 'checkedBy',
    headerName: 'Checked By',
    flex: 1,
    valueGetter: (value, row) =>
      row.checkedBy
        ? `${row.checkedBy.firstName ?? ''} ${row.checkedBy.lastName ?? ''}`.trim()
        : '-',
  },
  {
    field: 'source',
    headerName: 'Type',
    flex: 0.8,
    sortable: false,
    filterable: false,
    renderCell: ({ row }) => (
      <Chip
        size="small"
        label={TYPE_LABEL[row.source] || row.source}
        color={row.source === 'quick_add' ? 'info' : 'default'}
      />
    ),
  },
  {
    field: 'summary',
    headerName: 'Summary',
    flex: 2,
  },
]

export default historyColumns
